<template>
    <div class="home-dj" @click="makeOrder">
        <div class="goods_pic">
            <div class="box">
                <van-image class="goods_icon" :src="row.icon_url" />
            </div>
        </div>
        <div class="goods_info">
            <div class="tit">
                {{ row.goods_name }}
            </div>
            <div class="server">{{ row.server_name }}</div>
            <div class="server_num">
                <p class="server_name">单价：&yen;{{ row.price }}</p>
                <p class="num">数量：{{ row.num }}</p>
            </div>
        </div>
        <div class="price_buy">
            <p class="price">
                <span class="price_tit">总价</span>
                <i>&yen;</i>
                <span class="price_int">{{ pricePart.int }}</span>
                <span class="price_dot" v-if="pricePart.dec !== ''">.</span>
                <span class="price_dec" v-if="pricePart.dec !== ''">{{ pricePart.dec }}</span>
            </p>
            <van-button type="primary" round class="buy_btn">购买</van-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'home-dj',
    props: {
        row: [Array, Object],
    },
    filters: {

    },
    data() {
        return {

        }
    },
    computed: {
        pricePart() {
            const value = this.row && (this.row.price*this.row.num).toFixed(2)
            if (value === null || value === undefined || value === '') {
                return { int: '', dec: '' }
            }
            const str = String(value)
            const parts = str.split('.')
            return {
                int: parts[0] || '0',
                dec: parts.length > 1 ? (parts[1] || '') : ''
            }
        }
    },
    methods: {
        makeOrder() {
            this.$router.push({
              name: 'order',
              query: {
                id: this.row.id
              }
            })
        }
    },
}
</script>
<style lang="less" scoped>
.home-dj {
    width: 100%;
    padding: 1.2rem 1rem;
    margin-top: 1rem;
    background: #fff;
    border-radius: 1rem;
    border: 1px solid #FFDCCB;
    display: flex;
    align-items: center;
    cursor: pointer;
    .goods_pic {
        width: 7rem;
        height: 7rem;
        border-radius: 1rem;
        margin-right: .8rem;
        overflow: hidden;
        background: url(../assets/bx/goods_bg.png) no-repeat 0 0 / 100% 100%;
        position: relative;
        .box {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            width: 4rem;
            height: 4rem;
            background: url(../assets/bx/goods_kuang.png) no-repeat 0 0 / 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .goods_icon {
                width: 95%;
                height: 95%;
                border-radius: .6rem;
                overflow: hidden;
            }
        }
    }
    .goods_info {
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .tit {
            font-size: 1.4rem;
            line-height: 1.5;
            color: #000;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            font-weight: 700;
            i {
                display: inline-block;
                font-size: 1rem;
                height: 1.6rem;
                line-height: 1.8rem;
                padding: 0 0.8rem;
                background-color: var(--theme);
                -webkit-transform: scale(0.9) translateY(-0.1rem);
                transform: scale(0.9) translateY(-0.1rem);
                -webkit-transform-origin: 0 center;
                transform-origin: 0 center;
                color: #fff;
                border-radius: 0.2rem;
                font-weight: 400;
            }
        }
        .server_num {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .server {
            font-size: 1.2rem;
            color: #999;
        }
        .name {
            font-size: 1.4rem;
            color: #000;
            font-weight: 700;
            margin-bottom: .4rem;
        }
        .server_name {
            font-size: 1.2rem;
            color: #999;
            max-width: 70%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .num {
            font-size: 1.2rem;
            color: #999;
        }
    }
    .price_buy {
        margin-left: 2.5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .price_tit {
            width: 100%;
            text-align: center;
            font-size: 1.2rem;
            color: #999;
            font-weight: normal;
            margin-right: .4rem;
        }
        .price {
            color: #EF4D3D;
            font-size: 1.6rem;
            font-weight: 700;
            text-align: end;
            i {
                font-size: 1.2rem;
                margin-right: .1rem;
            }
            .price_dec {
                font-size: 1.4rem;
            }
        }
        .buy_btn {
            width: 8rem;
            height: 2.8rem;
            line-height: 2.8rem;
            text-align: center;
            font-size: 1.4rem;
            margin-top: .7rem;
            background-color: var(--theme);
            border: none;
            outline: none;
        }
    }

}
</style>
